import { useState } from 'react';
import './TokiPona.scss';
import Button from '../../components/Button/Button';

const tokiPonaWords = [
    { word: 'a', meaning: 'ah, oh, emphasis', spanish: 'ah, oh, énfasis' },
    { word: 'akesi', meaning: 'reptile, amphibian', spanish: 'reptil, anfibio' },
    { word: 'ala', meaning: 'no, not, zero', spanish: 'no, nada, cero' },
    { word: 'alasa', meaning: 'to hunt, to search', spanish: 'cazar, buscar' },
    { word: 'ale', meaning: 'all, everything, 100', spanish: 'todo, 100' },
    { word: 'anpa', meaning: 'bottom, down, below', spanish: 'abajo, bajo' },
    { word: 'ante', meaning: 'different, change', spanish: 'diferente, cambiar' },
    { word: 'anu', meaning: 'or', spanish: 'o' },
    { word: 'awen', meaning: 'to stay, to wait', spanish: 'quedarse, esperar' },
    { word: 'e', meaning: 'object marker', spanish: 'marcador de objeto' },
    { word: 'en', meaning: 'and (subjects)', spanish: 'y (sujetos)' },
    { word: 'esun', meaning: 'market, shop, trade', spanish: 'mercado, tienda' },
    { word: 'ijo', meaning: 'thing, object', spanish: 'cosa, objeto' },
    { word: 'ike', meaning: 'bad, negative', spanish: 'malo, negativo' },
    { word: 'ilo', meaning: 'tool, machine', spanish: 'herramienta, máquina' },
    { word: 'insa', meaning: 'inside, center', spanish: 'dentro, centro' },
    { word: 'jaki', meaning: 'dirty, gross', spanish: 'sucio, asqueroso' },
    { word: 'jan', meaning: 'person, human', spanish: 'persona, humano' },
    { word: 'jelo', meaning: 'yellow', spanish: 'amarillo' },
    { word: 'jo', meaning: 'to have, to carry', spanish: 'tener, llevar' },
    { word: 'kala', meaning: 'fish, sea creature', spanish: 'pez, criatura marina' },
    { word: 'kalama', meaning: 'sound, noise', spanish: 'sonido, ruido' },
    { word: 'kama', meaning: 'to come, to become', spanish: 'venir, llegar a ser' },
    { word: 'kasi', meaning: 'plant, vegetation', spanish: 'planta, vegetación' },
    { word: 'ken', meaning: 'can, able, possible', spanish: 'poder, posible' },
    { word: 'kepeken', meaning: 'to use, using', spanish: 'usar, usando' },
    { word: 'kili', meaning: 'fruit, vegetable', spanish: 'fruta, verdura' },
    { word: 'kiwen', meaning: 'hard, stone, metal', spanish: 'duro, piedra, metal' },
    { word: 'ko', meaning: 'paste, powder, goo', spanish: 'pasta, polvo' },
    { word: 'kon', meaning: 'air, spirit, soul', spanish: 'aire, espíritu, alma' },
    { word: 'kule', meaning: 'color, colorful', spanish: 'color, colorido' },
    { word: 'kulupu', meaning: 'group, community', spanish: 'grupo, comunidad' },
    { word: 'kute', meaning: 'ear, to hear, listen', spanish: 'oído, oír, escuchar' },
    { word: 'la', meaning: 'context separator', spanish: 'separador de contexto' },
    { word: 'lape', meaning: 'sleep, rest', spanish: 'dormir, descansar' },
    { word: 'laso', meaning: 'blue, green', spanish: 'azul, verde' },
    { word: 'lawa', meaning: 'head, mind, to lead', spanish: 'cabeza, mente, liderar' },
    { word: 'len', meaning: 'cloth, clothing', spanish: 'tela, ropa' },
    { word: 'lete', meaning: 'cold, cool', spanish: 'frío' },
    { word: 'li', meaning: 'predicate marker', spanish: 'marcador de predicado' },
    { word: 'lili', meaning: 'small, little, young', spanish: 'pequeño, joven' },
    { word: 'linja', meaning: 'line, hair, rope', spanish: 'línea, pelo, cuerda' },
    { word: 'lipu', meaning: 'paper, document, book', spanish: 'papel, documento, libro' },
    { word: 'loje', meaning: 'red', spanish: 'rojo' },
    { word: 'lon', meaning: 'at, in, existing', spanish: 'en, existir' },
    { word: 'luka', meaning: 'hand, arm, 5', spanish: 'mano, brazo, 5' },
    { word: 'lukin', meaning: 'eye, to see, to look', spanish: 'ojo, ver, mirar' },
    { word: 'lupa', meaning: 'hole, door, window', spanish: 'agujero, puerta, ventana' },
    { word: 'ma', meaning: 'earth, land, country', spanish: 'tierra, país' },
    { word: 'mama', meaning: 'parent, creator', spanish: 'padre/madre, creador' },
    { word: 'mani', meaning: 'money, wealth', spanish: 'dinero, riqueza' },
    { word: 'meli', meaning: 'woman, female', spanish: 'mujer, femenino' },
    { word: 'mi', meaning: 'I, me, we', spanish: 'yo, nosotros' },
    { word: 'mije', meaning: 'man, male', spanish: 'hombre, masculino' },
    { word: 'moku', meaning: 'food, to eat', spanish: 'comida, comer' },
    { word: 'moli', meaning: 'death, to die', spanish: 'muerte, morir' },
    { word: 'monsi', meaning: 'back, behind', spanish: 'espalda, detrás' },
    { word: 'mu', meaning: 'animal sound', spanish: 'sonido animal' },
    { word: 'mun', meaning: 'moon, star', spanish: 'luna, estrella' },
    { word: 'musi', meaning: 'fun, game, art', spanish: 'diversión, juego, arte' },
    { word: 'mute', meaning: 'many, much, 20', spanish: 'mucho, muchos, 20' },
    { word: 'nanpa', meaning: 'number', spanish: 'número' },
    { word: 'nasa', meaning: 'strange, crazy, drunk', spanish: 'extraño, loco, borracho' },
    { word: 'nasin', meaning: 'way, path, method', spanish: 'camino, método' },
    { word: 'nena', meaning: 'bump, hill, nose', spanish: 'bulto, colina, nariz' },
    { word: 'ni', meaning: 'this, that', spanish: 'esto, eso' },
    { word: 'nimi', meaning: 'name, word', spanish: 'nombre, palabra' },
    { word: 'noka', meaning: 'foot, leg', spanish: 'pie, pierna' },
    { word: 'o', meaning: 'hey! (vocative)', spanish: 'hey! (vocativo)' },
    { word: 'olin', meaning: 'love', spanish: 'amor' },
    { word: 'ona', meaning: 'he, she, it, they', spanish: 'él, ella, ellos' },
    { word: 'open', meaning: 'to open, to start', spanish: 'abrir, empezar' },
    { word: 'pakala', meaning: 'broken, damage', spanish: 'roto, daño' },
    { word: 'pali', meaning: 'to do, to work', spanish: 'hacer, trabajar' },
    { word: 'palisa', meaning: 'stick, rod', spanish: 'palo, vara' },
    { word: 'pan', meaning: 'bread, grain', spanish: 'pan, grano' },
    { word: 'pana', meaning: 'to give, to send', spanish: 'dar, enviar' },
    { word: 'pi', meaning: 'of (regroups modifiers)', spanish: 'de (reagrupa)' },
    { word: 'pilin', meaning: 'heart, feeling', spanish: 'corazón, sentimiento' },
    { word: 'pimeja', meaning: 'black, dark', spanish: 'negro, oscuro' },
    { word: 'pini', meaning: 'end, finish, past', spanish: 'fin, terminar, pasado' },
    { word: 'pipi', meaning: 'bug, insect', spanish: 'bicho, insecto' },
    { word: 'poka', meaning: 'side, nearby', spanish: 'lado, cerca' },
    { word: 'poki', meaning: 'container, box', spanish: 'contenedor, caja' },
    { word: 'pona', meaning: 'good, simple, fix', spanish: 'bueno, simple, arreglar' },
    { word: 'pu', meaning: 'official Toki Pona book', spanish: 'libro oficial de TP' },
    { word: 'sama', meaning: 'same, similar', spanish: 'mismo, similar' },
    { word: 'seli', meaning: 'fire, heat', spanish: 'fuego, calor' },
    { word: 'selo', meaning: 'skin, shell, boundary', spanish: 'piel, cáscara, límite' },
    { word: 'seme', meaning: 'what? which?', spanish: '¿qué? ¿cuál?' },
    { word: 'sewi', meaning: 'up, above, divine', spanish: 'arriba, divino' },
    { word: 'sijelo', meaning: 'body, torso', spanish: 'cuerpo, torso' },
    { word: 'sike', meaning: 'circle, ball, cycle', spanish: 'círculo, bola, ciclo' },
    { word: 'sin', meaning: 'new, fresh, another', spanish: 'nuevo, fresco, otro' },
    { word: 'sina', meaning: 'you', spanish: 'tú, ustedes' },
    { word: 'sinpin', meaning: 'face, front, wall', spanish: 'cara, frente, pared' },
    { word: 'sitelen', meaning: 'image, picture, write', spanish: 'imagen, dibujo, escribir' },
    { word: 'sona', meaning: 'knowledge, to know', spanish: 'conocimiento, saber' },
    { word: 'soweli', meaning: 'animal, mammal', spanish: 'animal, mamífero' },
    { word: 'suli', meaning: 'big, important', spanish: 'grande, importante' },
    { word: 'suno', meaning: 'sun, light', spanish: 'sol, luz' },
    { word: 'supa', meaning: 'surface, table, floor', spanish: 'superficie, mesa, suelo' },
    { word: 'suwi', meaning: 'sweet, cute', spanish: 'dulce, lindo' },
    { word: 'tan', meaning: 'from, because', spanish: 'de, desde, porque' },
    { word: 'taso', meaning: 'but, only', spanish: 'pero, solo' },
    { word: 'tawa', meaning: 'to, toward, moving', spanish: 'a, hacia, moverse' },
    { word: 'telo', meaning: 'water, liquid', spanish: 'agua, líquido' },
    { word: 'tenpo', meaning: 'time, moment', spanish: 'tiempo, momento' },
    { word: 'toki', meaning: 'language, to speak', spanish: 'idioma, hablar' },
    { word: 'tomo', meaning: 'house, building, room', spanish: 'casa, edificio, cuarto' },
    { word: 'tu', meaning: 'two, divide', spanish: 'dos, dividir' },
    { word: 'unpa', meaning: 'sex, sexual', spanish: 'sexo, sexual' },
    { word: 'uta', meaning: 'mouth, lips', spanish: 'boca, labios' },
    { word: 'utala', meaning: 'battle, fight', spanish: 'batalla, pelear' },
    { word: 'walo', meaning: 'white, light-colored', spanish: 'blanco, claro' },
    { word: 'wan', meaning: 'one, unique, united', spanish: 'uno, único, unido' },
    { word: 'waso', meaning: 'bird, flying creature', spanish: 'pájaro, criatura voladora' },
    { word: 'wawa', meaning: 'power, energy, strong', spanish: 'poder, energía, fuerte' },
    { word: 'weka', meaning: 'away, absent, remove', spanish: 'lejos, ausente, quitar' },
    { word: 'wile', meaning: 'want, need, must', spanish: 'querer, necesitar, deber' },
];

export default function TokiPona() {
    const [search, setSearch] = useState('');

    // const [showSpanish, setShowSpanish] = useState(true);
    const [lang, setLang] = useState('en');

    const filteredWords = tokiPonaWords.filter(item =>
        item.word.includes(search.toLowerCase()) ||
        item.meaning.toLowerCase().includes(search.toLowerCase()) ||
        item.spanish.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div id="tokipona">
            <div className='centered-container'>
                <div className="header">
                    <h1>Sitelen Pona</h1>
                    <br />
                    <div className="controls flex gap flex-align-center">
                        <input
                            type="text"
                            placeholder="Buscar palabra..."
                            className="input"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <label>
                            <div className='flex gap flex-align-center'>
                                <Button
                                    className={`lang-button ${lang === 'en' ? 'active' : ''}`}
                                    onClick={() => setLang('en')}
                                    selected={lang === 'en'}
                                >
                                    EN
                                </Button>
                                <Button
                                    className={`lang-button ${lang === 'es' ? 'active' : ''}`}
                                    onClick={() => setLang('es')}
                                    selected={lang === 'es'}
                                >
                                    ES
                                </Button>
                            </div>
                        </label>
                    </div>
                    <p className="count margin-top">{filteredWords.length} palabras</p>
                </div>

                <div className="symbols-container">
                    {filteredWords.map((item) => (
                        <div key={item.word} className="symbol-card">
                            <img
                                className="sitelen"
                                src={require(`./sitelen/${item.word}.svg`)}
                                alt={item.word}
                            />
                            <div className="word"><b>{item.word}</b></div>
                            {lang === 'en' && <div className="meaning">{item.meaning}</div>}
                            {lang === 'es' && <div className="spanish">{item.spanish}</div>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}